import React from 'react'

import { InfoTooltip } from '@fourthwall/components'

import * as S from './Header.styled'
import type { Props } from './types'

export const Header = ({ data }: Props) => {
  const { content, info } = data

  return (
    <S.Container>
      <S.InnerContainer>
        <S.Header>{content}</S.Header>
        <S.Tooltip>
          <InfoTooltip content={info} />
        </S.Tooltip>
      </S.InnerContainer>
    </S.Container>
  )
}
